import * as React from "react";

function SvgCurve1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path className="curve-1_svg__st2" d="M1610 177.3C1423 122.9 1133.3 88 808 88c-334.7 0-631.8 37-818 94.1v28h1620v-32.8z" /></svg>;
}

export default SvgCurve1;